<!-- Copyright (c) 2022 ForgeRock. All rights reserved.

This software may be modified and distributed under the terms
of the MIT license. See the LICENSE file for details. -->
<template>
  <BModal
    :title="`Delete ${name}?`"
    v-model="show"
    size="md"
    centered
    @hidden="$emit('hidden')"
  >
    <p class="m-0">
      Are you sure you want to delete {{ name }}?
    </p>
    <template #modal-footer="{ cancel }">
      <BButton
        size="md"
        variant="link"
        @click="cancel()">
        Cancel
      </BButton>
      <LoadingButton
        size="md"
        variant="primary"
        label="Delete"
        :loading="loading"
        :disabled="name === ''"
        @click="handleDelete" />
    </template>
  </BModal>
</template>
<script>
import { BModal, BButton } from 'bootstrap-vue';
import LoadingButton from '../../Shared/LoadingButton';
import { deletePipeline } from '../api/PipelineApi';

export default {
  name: 'DeletePipelineModal',
  components: {
    BModal,
    BButton,
    LoadingButton,
  },
  props: {
    pipeline: {
      type: Object,
    },
    showModal: {
      type: Boolean,
    },
  },
  data() {
    return {
      show: false,
      loading: false,
    };
  },
  watch: {
    showModal(val) {
      this.show = val;
    },
  },
  computed: {
    name() {
      return this.pipeline ? this.pipeline.pipeline_name : '';
    },
  },
  methods: {
    handleDelete() {
      this.loading = true;
      deletePipeline(this.pipeline)
        .then((response) => {
          this.loading = false;
          this.$emit('deleted');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
